/**
 * Legend width computation for the Header row legend.
 *
 * ## Layout
 *
 *   ┌──────────────────────────────────┐
 *   │ #time-label (std-row)            │
 *   │  margin-left: 4px                │
 *   │  ┌────────────────────────────┐  │
 *   │  │ #title (h1.h6)             │  │
 *   │  │  "September 2026"          │  │
 *   │  │  padding-right: 8px        │  │
 *   │  └────────────────────────────┘  │
 *   └──────────────────────────────────┘
 *   SheetLegend #root: padding-left: 8px
 *
 * ## Constants (from layout CSS)
 *
 *   timeLabelMarginL =  4px  (#time-label margin-left)
 *   titlePadR        =  8px  (#title padding-right)
 *   SheetLegendPad   =  8px  (SheetLegend #root padding-left)
 *                    ──────
 *   OVERHEAD         = 20px
 *
 * ## Font
 *
 * `#title` uses `h1.h6` → `--h6-size` (Typography).
 * Accessed via `measure.fonts["title"]`.
 *
 * ## Notes
 *
 * The header legend shows month + year from the anchor date. Since
 * computeWidth doesn't receive the date, we use "September" (longest
 * English month name) as a conservative estimate.
 */

import type { TextMeasurer } from "../../../../sheet/default-legend-layout.ts";

const OVERHEAD = 20;
const LONGEST_MONTH = "September";

/**
 * Compute the natural width of a HeaderLegend in pixels.
 */
function headerLegendWidth(measure: TextMeasurer): number {
  const font = measure.fonts["title"] ?? null;
  const text = `${LONGEST_MONTH} 2026`;
  return Math.ceil(measure.measureText(text, font)) + OVERHEAD;
}

export namespace HeaderLegendLayout {
  export const width = headerLegendWidth;
}
